module.exports = __webpack_public_path__ + "assets/img/border-f575c29a.png";